const ERROR_COUNTER_KEY = "generic-error-counter"

export const getErrorCounter = (): number => {
    try {
        const value = sessionStorage.getItem(ERROR_COUNTER_KEY) || "0"
        return parseInt(value, 10)
    } catch (e) {
        return 0
    }
}

const storeErrorCounter = (counter: number) => {
    sessionStorage.setItem(ERROR_COUNTER_KEY, counter.toString())
}

export const resetErrorCounter = () => {
    sessionStorage.removeItem(ERROR_COUNTER_KEY)
}

export const incrementErrorCounter = () => {
    const value = getErrorCounter()
    storeErrorCounter(value + 1)
}
